export const GENERIC_ERROR = 'Erro desconhecido, por favor entre em contato com o suporte.';
export const INVALID_DATE = 'Invalid Date';

export const PHONE_8_NUMBERS_MASK = '(99) 9999-9999';
export const PHONE_9_NUMBERS_MASK = '(99) 99999-9999';

export const COMPANY_ACRONYM_LENGTH = 5;
export const SECTOR_ACRONYM_LENGTH = 4;
